import { render, staticRenderFns } from "./ReportMaintenanceChip.vue?vue&type=template&id=23ada548&"
import script from "./ReportMaintenanceChip.vue?vue&type=script&lang=js&"
export * from "./ReportMaintenanceChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports